<template>
<div id="adminThemeDiv" :key="count">
    <div class="mcc-page-header" :class="storeTheme.fixedHeader ? 'fixedPageHeader' : ''">
        <div class="mu-d-flex">

            <section class="mu-d-flex mu-flex-row">

                <h1 class="mu-mb-00">Themes</h1>

                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
            <section>

            </section>
        </div>
        <div>
        </div>
    </div>
    <div class="mcc-container card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Administration</li>
                <li aria-current="page">Themes</li>
                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>
        <div class="mcc-card">
            <div class="mcc-card__body">
                <div class="mcc-row">
                    <div class="mcc-col">
                        <div style="position:relative">
                            <div v-show="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <form novalidate v-show="dataLoaded" id="adminThemesForm" @submit.prevent="saveTheme()">
                                <div class="mcc-row">
                                    <div class="mcc-col mcc-col-12 mcc-col-md-6">
                                        <div class="mcc-card fullHeightCard">
                                            <div class="mcc-card__header">
                                                <h2 class="mcc-card__title  ">Theme</h2>
                                            </div>
                                            <div class="mcc-card__body">
                                                <div class="mcc-row mu-mb-05 mu-d-none">
                                                    <div class="mcc-col-8">
                                                        <div class="mfc-slim-select-wrapper">
                                                            <label for="themeCode" class="mu-mb-00">Select theme</label>
                                                            <select @change="changeThemeDropdown" ref="themeRef" class="mfc-slim-select" name="themeCode" id="themeCode" required block>
                                                                <option value="theme-default" :selected="theme == null || theme.themeCode == null || theme.themeCode == '' || theme.themeCode == 'theme-default'">
                                                                    Default</option>
                                                                <option :selected="theme && theme.themeCode == uTheme.code" v-for="(uTheme, key) in userDefinedThemes" :key="key" :value="uTheme.code">{{ uTheme.name }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="mcc-col-4">
                                                        <div class="d-flex">
                                                            <button class="mcc-button mcc-button--outline mu-position-absolute" style="margin-top: 26px;" id="show-dialog" @click="showThemeDialog" type="button">
                                                                <span class="mcc-button__label">Customize</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mu-mb-05">
                                                    <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                        <input type="checkbox" id="menuOnTop" name="menuOnTop" :value="theme.menuOnTop ? theme.menuOnTop : false" :checked="theme.menuOnTop" @change="theme.menuOnTop = $event.target.checked" color="primary" class="mfc-switch">
                                                        <label for="menuOnTop">Menu on top</label>
                                                    </div>
                                                </div>
                                                <div class="mu-mb-05">
                                                    <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                        <input type="checkbox" class="mfc-switch" id="fixedHeader" name="fixedHeader" :value="theme.fixedHeader ? theme.fixedHeader : false" :checked="theme.fixedHeader" @change="theme.fixedHeader = $event.target.checked" color="primary">
                                                        <label for="fixedHeader">Fixed header</label>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                        <input type="checkbox" class="mfc-switch" id="fixedFooter" name="fixedFooter" :value="theme.fixedFooter ? theme.fixedFooter : false" :checked="theme.fixedFooter" @change="theme.fixedFooter = $event.target.checked" color="primary">
                                                        <label for="fixedFooter">Fixed footer</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mcc-col mcc-col-12 mcc-col-md-6">
                                        <div class="mcc-card fullHeightCard">
                                            <div class="mcc-card__header">
                                                <h2 class="mcc-card__title  ">Product settings</h2>
                                            </div>
                                            <div class="mcc-card__body">
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05">
                                                    <label for="productName" class="mfc-label--required">Product
                                                        name</label>
                                                    <input ref="productName" :value="theme.productName" :pattern="nameRegex" @change="updateProductName($event)" type="text" id="productName" name="productName" required="" placeholder="Product name" maxlength="50">
                                                </div>
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05">
                                                    <label for="productStrapline" class="mfc-label--required">Product
                                                        strapline</label>
                                                    <input type="text" id="productStrapline" name="productStrapline" ref="productStrapline" :value="theme.productStrapline" :pattern="straplineRegex" @change="theme.productStrapline = $event.target.value" required="" placeholder="Product strapline" maxlength="50">

                                                </div>

                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                    <label for="logoInput">Add/Change logo</label>
                                                    <input type="file" id="logoInput" name="logo" @change="logoChangeEvent($event)" accept="image/*">

                                                </div>
                                                <img class="mu-border mu-radius-01 mu-p-02 mu-h-auto mu-mt-03" :class="showLogo ? 'showElement' : 'hideElement'" id="logoImage" name="logo" :src="(theme.logo != null && theme.logo != '') ? theme.logo : '#'" alt="" style="background: var(--mds-color-secondary-soft, #eeeef1);">
                                                <button type="button" :class="showLogo ? '' : 'mu-d-none'" class="mcc-button mcc-button--icon-only mcc-button--sm mcc-button--text mu-ml-03" id="removeLogo" @click="removeLogo()">
                                                    <mcc-icon name="trash" aria-hidden="true"></mcc-icon>
                                                </button>

                                                <span :class="!showLogo ? 'showElement mu-mb-05' : 'hideElement mu-mb-05'">Custom logo is not
                                                    set</span>

                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                    <label for="faviconInput">Add/Change favicon</label>
                                                    <input type="file" id="faviconInput" name="favicon" accept="image/*" @change="faviconChangeEvent($event)">

                                                </div>
                                                <img class="mu-border mu-radius-01 mu-p-02 mu-h-auto mu-mt-03" :class="showFavicon ? 'showElement' : 'hideElement'" id="faviconImage" name="favicon" :src="(theme.favicon != null && theme.favicon != '') ? theme.favicon : '#'" alt="" style="background: var(--mds-color-secondary-soft, #eeeef1);">
                                                <button type="button" :class="showFavicon ? '' : 'mu-d-none'" class="mcc-button mcc-button--icon-only mcc-button--sm mcc-button--text mu-ml-03" id="removeFavicon" @click="removeFavicon()">
                                                    <mcc-icon name="trash" aria-hidden="true"></mcc-icon>
                                                </button>

                                                <span :class="!showFavicon ? 'showElement' : 'hideElement'">Favicon is not
                                                    set</span>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end mu-mt-05" spaced="">
                                        <button type="submit" class="mcc-button mcc-button--success" id="saveBtn" title="Save" >
                                            <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    EventBus
} from "../../../services/event-bus";
import {
    mapState
} from "vuex";
import constantMessages from "../../../messages";
import AdminThemesAPI from "../../../services/AdminThemesAPI";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    computed: {
        ...mapState(['userDefinedThemes'])

    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["admin.themes"],
            nameRegex: constantMessages.PATTERNS["customName"],
            straplineRegex: constantMessages.PATTERNS["strapline"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            updateCall: true,
            count: 0,
            dataLoaded: false,
            storeTheme: {},
            mosaicColorList: [{
                    name: "Default",
                    value: "#242424"
                },
                {
                    name: "Slack",
                    value: "#400040"
                },
                {
                    name: "Olive",
                    value: "#666600"
                },
                {
                    name: "Orange",
                    value: "#d23600"
                },
                {
                    name: "Gray",
                    value: "#5f5f5f"
                },
                {
                    name: "Navy blue",
                    value: "#293462"
                },
                {
                    name: "Chocolate",
                    value: "#472323"
                },
                {
                    name: "Red",
                    value: "#ff0000"
                },
            ],
            theme: {
                fixedFooter: false,
                fixedHeader: false,
                menuOnTop: false,
                themeName: "#242424"
            },
            showLogo: false,
            showFavicon: false,
            isLogoInvalid: false,
            isFaviconInvalid: false,
            themeColor: ''
        };
    },
    mounted() {
        this.init();
        EventBus.$on("reload-admin-themes", () => {
            AdminThemesAPI.getAllUserDefinedThemes().then(result => {
                this.$store.dispatch("fetchUserDefinedThemes", result)
                this.init();
                EventBus.$emit("updateTheme", this.$store.getters.getThemeData);
            })
        });
        EventBus.$on("exitPreviewMode", () => {
            this.theme.themeCode = this.storeTheme.themeCode;
            this.$refs.themeRef.value = this.theme.themeCode;
        })

    },
    beforeDestroy() {
        EventBus.$off("exitPreviewMode");
        EventBus.$off("reload-admin-themes");
    },
    methods: {
        init() {
            let self = this;
            self.updateCall = false;
            AdminThemesAPI.getTheme()
                .then(result => {
                    self.theme = result;
                    let isThemeCode = false;
                    for (let i = 0; i < self.userDefinedThemes.length; i++) {
                        if (self.theme.themeCode == self.userDefinedThemes[i].code) {
                            isThemeCode = true;
                        }
                    }
                    // if (!isThemeCode) {
                    //     self.theme.themeCode = "theme-default";
                    //     const theme = document.querySelector('mosaic-user-defined-theme')
                    //     theme.preview()
                    // }
                    // self.loadThemeData(self.theme.themeCode);
                    if (self.theme.logo != null && self.theme.logo != "") {
                        self.showLogo = true;
                    }
                    if (self.theme.favicon != null && self.theme.favicon != "") {
                        self.showFavicon = true;
                    }
                    self.storeTheme = JSON.parse(JSON.stringify(self.theme));
                    self.updateFixedHeader();
                })
                .finally(() => {
                    new SlimSelect({
                        select: '#themeCode',

                    })
                    self.updateCall = true;
                    self.dataLoaded = true;
                });
        },
        getDefaultThemeVariables() {
            return {
                "bottom-nav-background": "#242424",
                "bottom-nav-background-picker": "#242424",
                "font-family-sans-serif": "sans-serif",
                "nav-input-background-color": "#242424",
                "nav-input-background-color-picker": "#242424",
                "nav-input-border-color-focus": "#541454",
                "nav-input-border-color-focus-picker": "#541454",
                "nav-input-color": "#ffffff",
                "nav-input-color-picker": "#ffffff",
                "navbar-application-name-color": "#b3b3b3",
                "navbar-bg": "#242424",
                "navbar-bg-lg": "#242424",
                "navbar-bg-lg-picker": "#242424",
                "navbar-bg-picker": "#242424",
                "navbar-brand-bg": "#242424",
                "navbar-brand-bg-picker": "#242424",
                "navbar-brand-color": "#b3b3b3",
                "navbar-brand-color-picker": "#b3b3b3",
                "navbar-color": "#ffffff",
                "navbar-color-picker": "#ffffff",
                "navbar-nav-link-border": "1px solid #ffffff",
                "navbar-nav-link-color": "#ffffff",
                "navbar-nav-link-color-hover": "#e9510e",
                "navbar-nav-link-color-hover-picker": "#e9510e",
                "navbar-nav-link-color-picker": "#ffffff",
                "navbar-nav-link-disabled": "#414141",
                "navbar-nav-link-icon-fill": "#b3b3b3",
                "navbar-nav-link-icon-fill-hover": "#e9510e",
                "navbar-nav-link-icon-fill-hover-picker": "#e9510e",
                "navbar-nav-link-icon-fill-picker": "#b3b3b3",
                "navbar-navbar-nav": "#ffffff",
                "primary": "#1d428a",
                "sidebar-background-color": "#242424",
                "sidebar-background-color-picker": "#242424",
                "sidebar-border-color": "#571C5F",
                "sidebar-nav-item-collapse-background-color": "#242424",
                "sidebar-nav-item-collapse-background-color-picker": "#242424",
                "sidebar-nav-item-collapse-nav-link-background-color-hover": "#242424",
                "sidebar-nav-item-collapse-nav-link-background-color-hover-picker": "#242424",
                "sidebar-nav-link-background-color-active": "#242424",
                "sidebar-nav-link-background-color-active-picker": "#242424",
                "sidebar-nav-link-background-color-hover": "#242424",
                "sidebar-nav-link-background-color-hover-picker": "#242424",
                "sidebar-nav-link-border": "#000000",
                "sidebar-nav-link-border-color-active": "#e9510e",
                "sidebar-nav-link-border-color-active-picker": "#e9510e",
                "sidebar-nav-link-border-picker": "#000000",
                "sidebar-nav-link-color": "#b7b7b7",
                "sidebar-nav-link-color-active": "#ffffff",
                "sidebar-nav-link-color-active-picker": "#ffffff",
                "sidebar-nav-link-color-hover": "#ffffff",
                "sidebar-nav-link-color-hover-picker": "#ffffff",
                "sidebar-nav-link-color-picker": "#b7b7b7",
                "sidebar-nav-link-title": "#ffffff",
                "sidebar-nav-link-title-picker": "#ffffff",
                "sidebar-search-background-color": "#242424",
                "sidebar-search-background-color-picker": "#242424"

            }
        },
        loadThemeData(themeCode) {
            this.theme.themeCode = themeCode;
            if (this.theme.themeCode && this.theme.themeCode != 'theme-default') {
                const themeDTO = this.$store.getters.getThemeFromCode(this.theme.themeCode)
                const theme = document.querySelector('mosaic-user-defined-theme')
                const variables = JSON.parse(themeDTO.variables)
                theme.theme = variables;
                theme.preview()
            } else {
                const theme = document.querySelector('mosaic-user-defined-theme')

                theme.preview()
            }
            this.$store.dispatch('updatePreviewMode', true)
        },
        changeThemeDropdown(e) {
            this.theme.themeCode = e.target.value
            if (this.theme.themeCode && this.theme.themeCode != 'theme-default') {
                const themeDTO = this.$store.getters.getThemeFromCode(this.theme.themeCode)
                const theme = document.querySelector('mosaic-user-defined-theme')
                const variables = JSON.parse(themeDTO.variables)
                theme.theme = variables;
                theme.preview()
            } else {
                const theme = document.querySelector('mosaic-user-defined-theme')
                const variables = this.getDefaultThemeVariables();
                theme.theme = variables;
                theme.preview()
            }
            this.$store.dispatch('updatePreviewMode', true)
        },
        updateProductName(event){
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.productName), constantMessages.MESSAGES["error.name.required"])
                self.$refs.productName.classList.add("ms-is-invalid");
              
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.productName), constantMessages.MESSAGES["error.name.length"])
                self.$refs.productName.classList.add("ms-is-invalid");
               
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.productName), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.productName.classList.add("ms-is-invalid");
               
            }
            self.theme.productName = $event.target.value
        },
        showThemeDialog() {
            if (this.theme.themeCode == "theme-default") {
                let defaultThemeData = {
                    "code": "theme-default",
                    "name": "Default",
                    "variables": JSON.stringify(this.getDefaultThemeVariables())
                }
                EventBus.$emit('open-theme-dialog', defaultThemeData);
            } else {
                EventBus.$emit('open-theme-dialog', JSON.parse(JSON.stringify(this.$store.getters.getThemeFromCode(this.theme.themeCode))));
            }

        },
        saveTheme() {
            let self = this;
            let form = $('#adminThemesForm')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let a = form[0].checkValidity()
            self.updateCall = false;
            let file = null;
            let faviconFile = null;
            let abc = $('#adminThemesForm')
            let formDataArray = $('#adminThemesForm').serializeArray();
            let form_data = new FormData();
            for (let key in formDataArray) {
                form_data.append(formDataArray[key].name, formDataArray[key].value);
            }
            if ($("#logoInput")[0].files[0] != undefined) {
                file = this.isLogoInvalid ? "" : $("#logoInput")[0].files[0];
            }

            if ($("#faviconInput")[0].files[0] != undefined) {
                faviconFile = this.isFaviconInvalid ? "" : $("#faviconInput")[0].files[0];
            }

            form_data.append("logo", file);
            form_data.append("favicon", faviconFile);
            let toggleData = $('input[type=checkbox]:not(:checked)').map(function () {
                return {
                    name: this.name,
                    value: this.checked ? this.value : "false"
                };
            });
            for (let key in toggleData) {
                form_data.append(toggleData[key].name, toggleData[key].value);
            }
            AdminThemesAPI.saveTheme(form_data)
                .then(response => {
                    if (response.error) {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    } else {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        EventBus.$emit("updateTheme", response.data);
                        EventBus.$emit("updateFooter", response.data.fixedFooter);
                        self.$store.dispatch("fetchThemeData", response.data);
                        EventBus.$emit("update-pageTitle", self.$route.meta.title);
                        self.storeTheme = response.data;
                        self.updateFixedHeader();
                        setTimeout(() => {
                            if (response.data.logo != null &&  response.data.logo != "") {
                                self.showLogo = true;
                                $('#logoImage').attr('src', response.data.logo);
                            }
                            if (response.data.favicon != null &&  response.data.favicon != "") {
                                self.showFavicon = true;
                                $('#faviconImage').attr('src', response.data.favicon);
                            }
                        }, 0);
                    }
                })
                .finally(() => {
                    new SlimSelect({
                        select: '#themeCode',

                    })
                    self.updateCall = true;
                });
        },
        updateFixedHeader() {
            Utils.applyFixedHeaderConfiguration(this);
            this.count = this.count + 1;
        },
        logoChangeEvent(e) {
            if (e.target.files && e.target.files[0]) {
                this.validateLogoFile(e.target.files);
            }
        },
        faviconChangeEvent(e) {
            if (e.target.files && e.target.files[0]) {
                this.validateFaviconFile(e.target.files);
            }
        },
        validateLogoFile(files) {

            let self = this;

            let file = files[0];
            let fileExtension = file.name.split('.').pop().toLowerCase();

            if (!(fileExtension === "png" || fileExtension === "bpm" || fileExtension === "jpeg" || fileExtension === "jpg" ||
                    fileExtension === "svg" || fileExtension === "ico")) {
                EventBus.$emit("error-notification", {
                    msg: constantMessages.MESSAGES["message.themes.logo.notallowed.file.msg"]
                });
                self.isLogoInvalid = true;
                self.showLogo = false;
                $('#logoImage, #logoImage img').attr('src', "#");
                return;
            }

            if (file.size > 500000) {
                EventBus.$emit("error-notification", {
                    msg: constantMessages.MESSAGES["message.themes.logo.size.exceeded.file.msg"]
                });
                self.isLogoInvalid = true;
                self.showLogo = false;
                $('#logoImage, #logoImage img').attr('src', "#");
                return;
            }

            let reader = new FileReader();
            reader.onload = function (e) {
                self.showLogo = true;
                setTimeout(() => {
                    $('#logoImage').attr('src', e.target.result);
                }, 0);
                self.isLogoInvalid = false;
                self.theme.logo = $('#logoImage').attr('src');
            }
            reader.readAsDataURL(file);
        },
        validateFaviconFile(files) {

            let self = this;

            let file = files[0];
            let fileExtension = file.name.split('.').pop().toLowerCase();

            if (!(fileExtension === "png" || fileExtension === "bpm" || fileExtension === "jpeg" || fileExtension === "jpg" ||
                    fileExtension === "ico")) {
                EventBus.$emit("error-notification", {
                    msg: constantMessages.MESSAGES["message.themes.favicon.notallowed.file.msg"]
                });
                self.isFaviconInvalid = true;
                self.showFavicon = false;
                $('#faviconImage, #faviconImage img').attr('src', "#");
                return;
            }

            if (file.size > 500000) {
                EventBus.$emit("error-notification", {
                    msg: constantMessages.MESSAGES["message.themes.logo.size.exceeded.file.msg"]
                });
                self.isFaviconInvalid = true;
                self.showFavicon = false;
                $('#faviconImage, #faviconImage img').attr('src', "#");
                return;
            }

            let reader = new FileReader();
            reader.onload = function (e) {
                self.showFavicon = true;
                setTimeout(() => {
                    $('#faviconImage').attr('src', e.target.result);
                }, 0);
                self.isFaviconInvalid = false;
                self.theme.favicon = $('#faviconImage').attr('src');
            }
            reader.readAsDataURL(file);
        },
        removeLogo() {
            AdminThemesAPI.removeLogo().then(result => {
                if (!result.error) {
                    this.showLogo = false;
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[result.message]
                    });
                    EventBus.$emit("updateTheme", result.data);
                    $("#logoImage img").attr("src", "#");
                    $("#logoInput")[0].value = "";
                    $("#logoInput .file-list-desc")[0].textContent = "";
                }
            })
        },
        removeFavicon() {
            AdminThemesAPI.removefavicon().then(result => {
                this.showFavicon = false;
                if (!result.error) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[result.message]
                    });
                    EventBus.$emit("updateTheme", result.data);
                    $("#faviconImage img").attr("src", "#");
                    $("#faviconInput")[0].value = "";
                    $("#faviconInput .file-list-desc")[0].textContent = "";
                }
            })
        },
    }
};
</script>

<style scoped>
.mfc-input-wrapper input:not(:where([type=checkbox], [type=radio], [type=range], [type=submit])):not(:is([disabled], .flatpickr)):read-only {
    color: black;
}

.fullHeightCard {
    min-height: 100%;
}
</style>
